import router from "@/router/router"

export async function parsingAxiosError(error) {
	if (error.response.status == 401) {
		localStorage.removeItem("JWT")
		router.push({ path: "/login", name: "login" }).catch(err => {
			if (err.name !== "NavigationDuplicated") {
				return false
			}
		})
		return
	}
}
